import React from 'react';
import { BlogCard, BlogPost } from './BlogCard';
import { Button } from '../ui/Button';
const BLOG_POSTS: BlogPost[] = [{
  id: '1',
  title: 'Where Compassion Meets Care: Celebrating Mabel for CRNA Week',
  excerpt: 'Meet Mabel Okungbowa, a Certified Registered Nurse Anesthetist whose dedication to patient care exemplifies the spirit of our locum tenens community.',
  category: 'Provider Spotlight',
  image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=800&h=500&fit=crop',
  date: 'Jan 24, 2024',
  readTime: '6 min read'
}, {
  id: '2',
  title: '5 Tips for Your First Locum Tenens Assignment',
  excerpt: 'Starting your first locum assignment? Here are the essential tips to ensure a smooth transition and successful placement.',
  category: 'Provider Resources',
  image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&h=500&fit=crop',
  date: 'Jan 22, 2024',
  readTime: '4 min read'
}, {
  id: '3',
  title: '2024 Healthcare Staffing Outlook',
  excerpt: 'An in-depth analysis of the trends shaping the healthcare workforce this year, from shortages to technological adoption.',
  category: 'Industry News',
  image: 'https://images.unsplash.com/photo-1504813184591-01572f98c85f?w=800&h=500&fit=crop',
  date: 'Jan 20, 2024',
  readTime: '7 min read'
}, {
  id: '4',
  title: 'Cardiologist Salary Guide',
  excerpt: 'Explore current salary trends for invasive and non-invasive cardiologists in the current market.',
  category: 'Salary Guides',
  image: 'https://images.unsplash.com/photo-1559757175-5700dde675bc?w=800&h=500&fit=crop',
  date: 'Jan 18, 2024',
  readTime: '5 min read'
}, {
  id: '5',
  title: 'Understanding Malpractice Insurance for Locums',
  excerpt: 'Everything you need to know about malpractice coverage when working as a locum tenens provider.',
  category: 'Provider Resources',
  image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&h=500&fit=crop',
  date: 'Jan 15, 2024',
  readTime: '6 min read'
}, {
  id: '6',
  title: 'Emergency Medicine Salary Guide',
  excerpt: 'Detailed breakdown of compensation for emergency medicine physicians by state and facility type.',
  category: 'Salary Guides',
  image: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=800&h=500&fit=crop',
  date: 'Jan 12, 2024',
  readTime: '5 min read'
}, {
  id: '7',
  title: 'The Rise of Telehealth Locum Positions',
  excerpt: 'How virtual care is creating new opportunities for locum tenens providers to work from anywhere.',
  category: 'Industry News',
  image: 'https://images.unsplash.com/photo-1587351021759-3e566b6af7cc?w=800&h=500&fit=crop',
  date: 'Jan 10, 2024',
  readTime: '4 min read'
}, {
  id: '8',
  title: 'How to Negotiate Your Locum Tenens Contract',
  excerpt: 'Key strategies for negotiating better rates, schedules, and terms in your next locum contract.',
  category: 'Provider Resources',
  image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&h=500&fit=crop',
  date: 'Jan 08, 2024',
  readTime: '6 min read'
}, {
  id: '9',
  title: 'Anesthesiologist Salary Guide',
  excerpt: 'Current compensation benchmarks for anesthesiologists and CRNAs in the locum tenens market.',
  category: 'Salary Guides',
  image: 'https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=800&h=500&fit=crop',
  date: 'Jan 05, 2024',
  readTime: '5 min read'
}];
export function BlogGrid() {
  return <section className="pt-10 pb-20 bg-slate-50/50" data-id="element-71">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-72">
        <div className="flex items-end justify-between mb-12" data-id="element-73">
          <div data-id="element-74">
            <h2 className="text-3xl font-medium text-[#1a365d] mb-3" data-id="element-75">
              Latest Articles
            </h2>
            <p className="text-slate-500 font-light" data-id="element-76">
              Explore our most recent insights and updates.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12" data-id="element-77">
          {BLOG_POSTS.map((post, index) => <BlogCard key={post.id} post={post} index={index} data-id="element-78" />)}
        </div>

        <div className="mt-20 text-center" data-id="element-79">
          <Button variant="white" size="lg" className="border border-slate-200 text-slate-700 hover:bg-white hover:text-[#1a365d] hover:border-[#1a365d] transition-all duration-300 min-w-[200px]" style={{
          fontFamily: "'Poppins', sans-serif"
        }} data-id="element-80">
            Load More Articles
          </Button>
        </div>
      </div>
    </section>;
}